import { useQuery } from '@apollo/client/react';
import { GET_PLANS } from '@/graphql/queries/plans';
import type { PlanData } from '../types';

type UseGetPlansResult = {
  plans: PlanData[];
  isLoading: boolean;
  error: Error | undefined;
  refetch: () => void;
};

export function useGetPlans(): UseGetPlansResult {
  const { data, loading, error, refetch } = useQuery(GET_PLANS, { fetchPolicy: 'cache-first' });
  return {
    plans: data?.plans ?? [],
    isLoading: loading && !data,
    error,
    refetch: () => void refetch(),
  };
}
